module.exports = __webpack_public_path__ + "img/RTF_SMALL.bfb62bf.svg";